import { occurrenceSchema, type Occurrence } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postUnpay = (id: string): Promise<unknown> =>
  apiRequest<unknown>(`/occurrences/${id}/unpay`, { method: 'POST' });

export const unpayOccurrence = async (id: string): Promise<Occurrence> =>
  occurrenceSchema.parse(await postUnpay(id));
